import Vue from 'vue'
import VueRouterReferer from '@tozd/vue-router-referer'
Vue.use(VueRouterReferer)
